import { useMemo } from 'react';
import { RadioOption } from 'components/RadioGroupField/RadioGroupField.component';
import { useTranslation } from 'react-i18next';
import {
  COMMERCIAL_PROPERTY,
  CommercialProperty,
  OWNER_OF_THE_BUSINESS,
  OwnerOfTheBusiness,
  REVENUE_MODEL,
  RevenueModel,
  SALE_TYPE,
  SaleType,
  Succession,
  SUCCESSION,
} from 'models/Listing';
import { YesNo } from 'models/Fields';

export function useGenerateSliderOptions() {
  const { t } = useTranslation();

  const ownerOfBusinessOptions = useMemo<RadioOption<OwnerOfTheBusiness>[]>(
    () => [
      { label: t('silentOwners'), value: OWNER_OF_THE_BUSINESS.SILENT },
      {
        label: t('workInTheBusiness'),
        value: OWNER_OF_THE_BUSINESS.WORK_IN_THE_BUSINESS,
      },
    ],
    [t],
  );

  const replaceOwnerBusinessOptions = useMemo<RadioOption<YesNo>[]>(
    () => [
      { label: t('yesThereIs'), value: YesNo.Yes },
      { label: t('noThereIsNot'), value: YesNo.No },
    ],
    [t],
  );

  const commercialPropertyOptions = useMemo<RadioOption<CommercialProperty>[]>(
    () => [
      { label: t('andAreSelling'), value: COMMERCIAL_PROPERTY.SELLING },
      { label: t('areNotSelling'), value: COMMERCIAL_PROPERTY.NOT_SELLING },
      {
        label: t('optionToPurchaseCommercialProperty'),
        value: COMMERCIAL_PROPERTY.WILL_OFFER,
      },
    ],
    [t],
  );

  const saleTypeOptions = useMemo<RadioOption<SaleType>[]>(
    () => [
      { label: t('share'), value: SALE_TYPE.SHARE },
      { label: t('asset'), value: SALE_TYPE.ASSET },
      { label: t('either'), value: SALE_TYPE.EITHER },
    ],
    [t],
  );

  const contractedCustomersOptions = useMemo<RadioOption<YesNo>[]>(
    () => [
      { label: t('yes'), value: YesNo.Yes },
      { label: t('no'), value: YesNo.No },
    ],
    [t],
  );

  const revenueModelOptions = useMemo<RadioOption<RevenueModel>[]>(
    () => [
      { label: t('adHoc'), value: REVENUE_MODEL.AD_HOC },
      { label: t('recurring'), value: REVENUE_MODEL.RECURRING },
      { label: t('commission'), value: REVENUE_MODEL.COMMISSION },
    ],
    [t],
  );

  const successionOptions = useMemo<RadioOption<Succession>[]>(
    () => [
      { label: t('gmInPlace'), value: SUCCESSION.GM_IN_PLACE },
      {
        label: t('gmRequired'),
        value: SUCCESSION.GM_REQUIRED,
      },
      {
        label: t('successorInPlace'),
        value: SUCCESSION.SUCCESSOR_IN_PLACE,
      },
    ],
    [t],
  );

  return {
    revenueModelOptions,
    ownerOfBusinessOptions,
    saleTypeOptions,
    replaceOwnerBusinessOptions,
    commercialPropertyOptions,
    successionOptions,
    contractedCustomersOptions,
  };
}
